module.exports = __webpack_public_path__ + "img/sent_blue.2f69ccc9.svg";